import { RouteObject } from "react-router";
import { MaintenanceCareLayout } from "./components/layout/MaintenanceCareLayout";
import { CareMain } from "./components/pages/care/CareMain";
import { CarePokkot } from "./components/pages/care/CarePokkot";
import { CareKimchi } from "./components/pages/care/CareKimchi";
import { Maintenance } from "./components/pages/maintenance/Maintenance";

// Only these exact care pages remain public. All other URLs show maintenance,
// including unknown care paths, sign-in, account and payment return URLs.
export const maintenanceRoutes: RouteObject[] = [
  {
    path: "/care",
    element: <MaintenanceCareLayout />,
    errorElement: <Maintenance />,
    children: [
      { index: true, element: <CareMain /> },
      { path: "pokkot", element: <CarePokkot /> },
      { path: "kimchi", element: <CareKimchi /> },
    ],
  },
  { path: "*", element: <Maintenance /> },
];
